// React
import React, { useEffect, useState } from "react";
// MUI
import { Card, Stack, Button, Container, Typography } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoInLineTable from "../../../common/GoInLineTable/GoInLineTable";
import DebitNoteLine from "./DebitNoteLine";
// Constants
import PermissionConstants from "../../../configs/PermissionConstants";
// Hooks
import usePermissions from "../../../hooks/usePermissions";
// Utils
import { DEBIT_NOTE_LINE_TABLE_HEADS } from "./DebitNote.utils";
import GoDialog from "../../../common/GoDialog/GoDialog";
// Service
import { del } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
import toast from "react-hot-toast";

import { Form, Formik } from "formik";
import { post, put } from "../../../services/FetchHelper";
import { DEBIT_NOTE_LINE_STATE, DEBIT_NOTE_LINE_SCHEMA } from "./DebitNote.utils";

const DebitNoteLines = ({ debitNoteId, debitNoteLines, reload }) => {
    const spinService = SpinService();
    const permissions = usePermissions();
    const [debitNoteLineState, setDebitNoteLineState] = useState(DEBIT_NOTE_LINE_STATE);
    const [allDebitNoteLines, setAllDebitNoteLines] = useState([]);
    const [debitNoteLineId, setDebitNoteLineId] = useState(undefined);
    const [confirm, setConfirm] = useState(false);

    const addNew = () => {
        if (allDebitNoteLines.find((item) => item.rowAction !== undefined && (item.rowAction === "new" || item.rowAction === "edit")) === undefined) {
            const nr = { ...DEBIT_NOTE_LINE_STATE, rowAction: 'new' }
            if (allDebitNoteLines === false) {
                setAllDebitNoteLines([nr])
            } else {
                setAllDebitNoteLines([...allDebitNoteLines, nr])
            }
            setDebitNoteLineState(nr);
        }
    };

    const onAction = (item, action) => {
        if (action === "edit" && allDebitNoteLines.find((item) => item.rowAction !== undefined && (item.rowAction === "new" || item.rowAction === "edit")) === undefined) {
            setDebitNoteLineId(item.id);
            setDebitNoteLineState(allDebitNoteLines.find((row) => row.id === item.id));
            setAllDebitNoteLines((prevFormFields) => prevFormFields.map(row => row.id === item.id ? { ...row, rowAction: 'edit' } : row));
        }
        if (action === "delete") {
            setDebitNoteLineId(item.id);
            setConfirm(true);
            return;
        }
    }

    useEffect(() => {
        setAllDebitNoteLines(debitNoteLines);
    }, [debitNoteLines]);


    const onClose = () => {
        reload();
        setDebitNoteLineId(undefined);
    };

    const handleClose = async (res) => {
        if (res) {
            spinService.on();
            const response = await del(EntityConstants.DEBIT_NOTE_LINES + `/${debitNoteLineId}`);
            if (response.status === 200) {
                toast.success(MessageContants.DEBIT_NOTE_LINE_DELETED);
            }
            reload();
            spinService.off();
        } else {
            setDebitNoteLineId(undefined);
        }
        setConfirm(false);
    };

    // const onCalcChange = (debitNoteLines) => {
    //     const lastRow = debitNoteLines.reduce((accumulator, currentValue) => {
    //         return {
    //             row_type: "total",
    //             account_code: "Total (AED)",
    //             amount: currentValue.amount && (Number(accumulator.amount) + Number(currentValue.amount)).toFixed(2),
    //         }
    //     }, {
    //         row_type: "total",
    //         account_code: "Total (AED)",
    //         amount: 0,
    //     });
    //     const totalRows = debitNoteLines.length > 0 && [...debitNoteLines, lastRow];
    //     setLines(totalRows);

    // };



    const handleSubmit = async (values) => {
        spinService.on();
        const isNewDebitNoteLine = values.id === undefined;
        if (isNewDebitNoteLine) {
            values.debit_note_id = debitNoteId;
        }
        const url = isNewDebitNoteLine ? EntityConstants.DEBIT_NOTE_LINES : EntityConstants.DEBIT_NOTE_LINES + `/${values.id}`;
        const method = isNewDebitNoteLine ? post : put;
        const response = await method(url, { debit_note_line: values });
        if ([200, 201].indexOf(response.status) > -1) {
            setDebitNoteLineState(DEBIT_NOTE_LINE_STATE);
            toast.success(isNewDebitNoteLine ? MessageContants.DEBIT_NOTE_LINE_CREATED : MessageContants.DEBIT_NOTE_LINE_UPDATED);
            onClose();
        }
        spinService.off();
    };


    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h4" gutterBottom>
                        Debit Note Lines
                    </Typography>
                    {
                        permissions.has(PermissionConstants.DEBIT_NOTE_CREATE) &&
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="eva:plus-fill" />}
                            onClick={addNew}
                        >
                            New Line
                        </Button>
                    }
                </Stack>
                <Card>
                    <Formik
                        enableReinitialize
                        initialValues={debitNoteLineState}
                        validationSchema={DEBIT_NOTE_LINE_SCHEMA}
                        onSubmit={(values) => handleSubmit(values)}
                    >
                        {({
                            values,
                            touched,
                            errors,
                            handleChange,
                            handleSubmit,
                        }) => (
                            <Form noValidate onSubmit={handleSubmit}>

                                <GoInLineTable
                                    tableHeads={DEBIT_NOTE_LINE_TABLE_HEADS}
                                    tableDatas={allDebitNoteLines}
                                    onAction={(row, action) => onAction(row, action)}
                                    editRowId={debitNoteLineId}
                                    formElement={<DebitNoteLine
                                        values={values}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        debitNoteId={debitNoteId}
                                        debitNoteLineId={debitNoteLineId}
                                        onClose={() => onClose()}
                                    />}
                                />
                            </Form>

                        )}
                    </Formik>
                </Card>
            </Container>
            <GoDialog
                open={confirm}
                title=""
                content="Are you sure you want to delete?"
                positive="Yes"
                negative="No"
                handleClose={(res) => handleClose(res)}
            />
        </React.Fragment>
    );
}

export default DebitNoteLines;